module.exports = __webpack_public_path__ + "static/media/no-data.0e8f4090.svg";